export default "__VITE_ASSET__e7c8a830__"